import React from "react";
import BaseButton from "../../button";
import { IStyledArguments } from "../../../types/styled-arguments";
import { styled } from "@material-ui/styles";

const RegisterStepButton = styled(props => (
  <BaseButton size="large" {...props} />
))((props: IStyledArguments) => ({
  marginTop: props.theme.spacing(3),
  width: "100%",
  padding: "12px 32px",
  fontSize: "1rem",
  fontWeight: 600,
  borderRadius: "12px",
  background: props.theme.palette.primary.main,
  transition: "all 0.3s ease",
  "&:hover": {
    background: props.theme.palette.primary.dark,
    transform: "translateY(-2px)",
    boxShadow: "0 8px 16px rgba(16, 21, 26, 0.16)",
  },
  [props.theme.breakpoints.down("sm")]: {
    marginTop: props.theme.spacing(2),
    padding: "10px 24px",
  },
}));

export default RegisterStepButton;
